var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11079_417735)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.379 109.949L115.784 120.669L103.927 116.2L108.522 105.48C110.397 106.349 112.361 107.168 114.364 107.923C116.368 108.678 118.38 109.358 120.379 109.949Z",
    fill: "#FF81AF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.968 115.394L117.232 121.148C117.989 121.433 118.343 122.267 118.025 123.01L95.3951 175.799C94.8115 177.16 93.2151 177.841 91.8295 177.319L78.8435 172.424C77.4579 171.901 76.8078 170.374 77.3915 169.013L100.021 116.224C100.34 115.481 101.211 115.109 101.968 115.394Z",
    fill: "#6DE4A2",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3182 158.108L93.6958 164.225",
    stroke: "#0D052C",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.661 133.981L98.2995 153.486",
    stroke: "#0D052C",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.65 44.8075C183.837 65.2689 176.309 91.1647 155.498 103.81C134.688 116.455 107.839 111.447 94.325 92.4C80.811 73.3527 85.3363 46.8969 104.636 32.1217C123.935 17.3464 151.29 19.3956 166.962 36.7905",
    fill: "#7774FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.65 44.8075C183.837 65.2689 176.309 91.1647 155.498 103.81C134.688 116.455 107.839 111.447 94.325 92.4C80.811 73.3527 85.3363 46.8969 104.636 32.1217C123.935 17.3464 151.29 19.3956 166.962 36.7905",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 35.0489,
    ry: 35.0635,
    transform: "matrix(0.935733 0.352709 -0.394006 0.919108 132.057 66.6498)",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.218 43.6904C154.367 47.6335 158.615 53.7926 160.063 60.8651",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5096 24.6759L81.382 28.9051C81.3766 29.0468 81.4459 29.1819 81.5666 29.2649L91.3433 36.1209C91.3824 36.1481 91.402 36.1941 91.3938 36.2396C91.3856 36.2851 91.351 36.3221 91.3046 36.335L79.6746 39.5688C79.5323 39.6086 79.4195 39.7122 79.3723 39.8463L75.5957 50.8219C75.5818 50.8673 75.5411 50.9004 75.4919 50.9065C75.4428 50.9125 75.3946 50.8902 75.3689 50.8497L68.5287 41.2777C68.445 41.1606 68.3064 41.0901 68.158 41.0892L56.0419 41.019C55.9931 41.0198 55.9481 40.9938 55.9262 40.9521C55.9043 40.9104 55.9093 40.8605 55.9391 40.8237L63.3408 31.6916C63.4318 31.58 63.4592 31.4326 63.414 31.2976L59.7078 20.2666C59.693 20.2226 59.7057 20.1744 59.7405 20.1425C59.7753 20.1106 59.8262 20.1004 59.8717 20.1162L71.2831 24.0353C71.4226 24.0846 71.5784 24.064 71.6983 23.9805L81.5234 17.2374C81.5625 17.2105 81.6144 17.2072 81.657 17.2289C81.6997 17.2506 81.7258 17.2935 81.7244 17.3396L81.5389 23.4637",
    fill: "#FFE483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5096 24.6759L81.382 28.9051C81.3766 29.0468 81.4459 29.1819 81.5666 29.2649L91.3433 36.1209C91.3824 36.1481 91.402 36.1941 91.3938 36.2396C91.3856 36.2851 91.351 36.3221 91.3046 36.335L79.6746 39.5688C79.5323 39.6086 79.4195 39.7122 79.3723 39.8463L75.5957 50.8219C75.5818 50.8673 75.5411 50.9004 75.4919 50.9065C75.4428 50.9125 75.3946 50.8902 75.3689 50.8497L68.5287 41.2777C68.445 41.1606 68.3064 41.0901 68.158 41.0892L56.0419 41.019C55.9931 41.0198 55.9481 40.9938 55.9262 40.9521C55.9043 40.9104 55.9093 40.8605 55.9391 40.8237L63.3408 31.6916C63.4318 31.58 63.4592 31.4326 63.414 31.2976L59.7078 20.2666C59.693 20.2226 59.7057 20.1744 59.7405 20.1425C59.7753 20.1106 59.8262 20.1004 59.8717 20.1162L71.2831 24.0353C71.4226 24.0846 71.5784 24.064 71.6983 23.9805L81.5234 17.2374C81.5625 17.2105 81.6144 17.2072 81.657 17.2289C81.6997 17.2506 81.7258 17.2935 81.7244 17.3396L81.5389 23.4637",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9614 43.68C75.9614 50.3328 70.6034 55.7262 63.9933 55.7274H63.8383L18.5928 55.5526C14.5425 55.533 10.8616 53.1791 9.12347 49.497C7.38531 45.815 7.89735 41.4561 10.4408 38.2836C12.9842 35.111 17.1089 33.6859 21.0521 34.6174C18.589 26.7373 22.8078 18.3159 30.5675 15.6233C38.3272 12.9306 46.8063 16.9457 49.692 24.6792C52.2923 22.7702 55.7375 22.4927 58.6064 23.9612C61.4753 25.4297 63.2817 28.3953 63.2803 31.6347V31.6638C63.518 31.6493 63.7577 31.643 63.9995 31.643C70.6037 31.6465 75.9568 37.0333 75.9614 43.68V43.68Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6919 24.6792C50.3213 26.3815 50.6433 28.1834 50.6426 29.9998C50.6425 30.5404 50.6143 31.0805 50.5578 31.6181",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6919 24.6792C50.3213 26.3815 50.6433 28.1834 50.6426 29.9998C50.6425 30.5404 50.6143 31.0805 50.5578 31.6181",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0522 34.6152C22.7322 35.0215 24.2872 35.8372 25.5803 36.9906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0522 34.6152C22.7322 35.0215 24.2872 35.8372 25.5803 36.9906",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0913 32.6873C60.6329 31.9911 62.3038 31.6324 63.9934 31.6348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0913 32.6873C60.6329 31.9911 62.3038 31.6324 63.9934 31.6348",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5109 49.3149C12.1229 48.0815 11.3287 46.3071 11.3306 44.4436C11.331 44.0748 11.3621 43.7068 11.4236 43.3433",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5109 49.3149C12.1229 48.0815 11.3287 46.3071 11.3306 44.4436C11.331 44.0748 11.3621 43.7068 11.4236 43.3433",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2031 20.831C28.6037 20.6007 29.0333 20.4258 29.4803 20.311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2031 20.831C28.6037 20.6007 29.0333 20.4258 29.4803 20.311",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.979 26.0477C24.979 24.286 25.9731 22.5263 27.3639 21.3989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.979 26.0477C24.979 24.286 25.9731 22.5263 27.3639 21.3989",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4731 43.7217L59.8805 46.2697",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5229 42.0493L61.9141 46.3736",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8354 42.6587L62.6229 44.0856",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.561 173.68C73.561 180.333 68.2031 185.726 61.5929 185.727H61.4379L16.1924 185.553C12.1421 185.533 8.46124 183.179 6.72308 179.497C4.98492 175.815 5.49696 171.456 8.04036 168.284C10.5838 165.111 14.7085 163.686 18.6517 164.617C16.1886 156.737 20.4074 148.316 28.1671 145.623C35.9268 142.931 44.4059 146.946 47.2916 154.679C49.8919 152.77 53.3372 152.493 56.206 153.961C59.0749 155.43 60.8813 158.395 60.8799 161.635V161.664C61.1176 161.649 61.3573 161.643 61.5991 161.643C68.2033 161.646 73.5564 167.033 73.561 173.68V173.68Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2915 154.679C47.9209 156.382 48.2429 158.183 48.2422 160C48.2421 160.54 48.2139 161.081 48.1574 161.618",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2915 154.679C47.9209 156.382 48.2429 158.183 48.2422 160C48.2421 160.54 48.2139 161.081 48.1574 161.618",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6519 164.615C20.3318 165.022 21.8868 165.837 23.1799 166.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6519 164.615C20.3318 165.022 21.8868 165.837 23.1799 166.991",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6909 162.687C58.2325 161.991 59.9034 161.632 61.5931 161.635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6909 162.687C58.2325 161.991 59.9034 161.632 61.5931 161.635",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1105 179.315C9.7225 178.082 8.9283 176.307 8.93018 174.444C8.93058 174.075 8.96169 173.707 9.02318 173.343",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1105 179.315C9.7225 178.082 8.9283 176.307 8.93018 174.444C8.93058 174.075 8.96169 173.707 9.02318 173.343",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8027 150.831C26.2033 150.601 26.6329 150.426 27.0799 150.311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8027 150.831C26.2033 150.601 26.6329 150.426 27.0799 150.311",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5786 156.048C22.5786 154.286 23.5727 152.526 24.9635 151.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5786 156.048C22.5786 154.286 23.5727 152.526 24.9635 151.399",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0728 173.722L57.4802 176.27",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1226 172.049L59.5137 176.374",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4351 172.659L60.2225 174.086",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.573 154.269C184.573 159.344 180.356 163.458 175.153 163.459H175.031L139.419 163.326C136.231 163.311 133.333 161.515 131.965 158.706C130.597 155.898 131 152.573 133.002 150.152C135.004 147.732 138.251 146.645 141.354 147.356C139.416 141.345 142.736 134.921 148.844 132.867C154.952 130.813 161.625 133.875 163.897 139.775C165.943 138.319 168.655 138.107 170.913 139.227C173.171 140.347 174.593 142.61 174.592 145.081V145.103C174.779 145.092 174.968 145.087 175.158 145.087C180.356 145.09 184.57 149.199 184.573 154.269V154.269Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.897 139.775C164.392 141.073 164.646 142.448 164.645 143.834C164.645 144.246 164.623 144.658 164.579 145.068",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.897 139.775C164.392 141.073 164.646 142.448 164.645 143.834C164.645 144.246 164.623 144.658 164.579 145.068",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.354 147.354C142.677 147.664 143.901 148.287 144.919 149.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.354 147.354C142.677 147.664 143.901 148.287 144.919 149.166",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.295 145.883C172.508 145.352 173.823 145.079 175.153 145.081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.295 145.883C172.508 145.352 173.823 145.079 175.153 145.081",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.419 158.567C134.326 157.626 133.701 156.273 133.703 154.851C133.703 154.57 133.727 154.289 133.776 154.012",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.419 158.567C134.326 157.626 133.701 156.273 133.703 154.851C133.703 154.57 133.727 154.289 133.776 154.012",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.983 136.84C147.298 136.664 147.636 136.53 147.988 136.443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.983 136.84C147.298 136.664 147.636 136.53 147.988 136.443",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.445 140.819C144.445 139.475 145.228 138.132 146.322 137.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.445 140.819C144.445 139.475 145.228 138.132 146.322 137.272",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.809 154.301L171.916 156.244",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.635 153.025L173.517 156.324",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.455 153.49L174.075 154.578",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7954 51.5327L32.3503 54.5355C32.4017 54.6366 32.5027 54.7064 32.6193 54.7215L42.1216 56.0391C42.1595 56.0442 42.1911 56.0694 42.2031 56.1041C42.215 56.1389 42.2052 56.177 42.1778 56.2025L35.3019 62.6C35.218 62.6784 35.1794 62.791 35.1985 62.9016L36.8243 71.92C36.8322 71.9567 36.8167 71.9943 36.7847 72.016C36.7526 72.0377 36.7102 72.0393 36.6765 72.0201L28.1719 67.7588C28.0678 67.7067 27.9435 67.7067 27.8394 67.7588L19.3392 72.0187C19.3054 72.0365 19.2638 72.0343 19.2323 72.013C19.2007 71.9916 19.1848 71.9549 19.1914 71.9186L20.8172 62.9002C20.8375 62.7898 20.7994 62.6769 20.7152 62.5986L13.835 56.2025C13.8076 56.177 13.7978 56.1389 13.8097 56.1041C13.8216 56.0694 13.8532 56.0442 13.8912 56.0391L23.3949 54.7215C23.5116 54.7064 23.6126 54.6366 23.6639 54.5355L27.9133 46.3259C27.9302 46.2932 27.9651 46.2725 28.0034 46.2725C28.0417 46.2725 28.0767 46.2932 28.0936 46.3259L30.3446 50.6745",
    fill: "#FFBA68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7954 51.5327L32.3503 54.5355C32.4017 54.6366 32.5027 54.7064 32.6193 54.7215L42.1216 56.0391C42.1595 56.0442 42.1911 56.0694 42.2031 56.1041C42.215 56.1389 42.2052 56.177 42.1778 56.2025L35.3019 62.6C35.218 62.6784 35.1794 62.791 35.1985 62.9016L36.8243 71.92C36.8322 71.9567 36.8167 71.9943 36.7847 72.016C36.7526 72.0377 36.7102 72.0393 36.6765 72.0201L28.1719 67.7588C28.0678 67.7067 27.9435 67.7067 27.8394 67.7588L19.3392 72.0187C19.3054 72.0365 19.2638 72.0343 19.2323 72.013C19.2007 71.9916 19.1848 71.9549 19.1914 71.9186L20.8172 62.9002C20.8375 62.7898 20.7994 62.6769 20.7152 62.5986L13.835 56.2025C13.8076 56.177 13.7978 56.1389 13.8097 56.1041C13.8216 56.0694 13.8532 56.0442 13.8912 56.0391L23.3949 54.7215C23.5116 54.7064 23.6126 54.6366 23.6639 54.5355L27.9133 46.3259C27.9302 46.2932 27.9651 46.2725 28.0034 46.2725C28.0417 46.2725 28.0767 46.2932 28.0936 46.3259L30.3446 50.6745",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.755 136.712L179.227 138.493C179.209 138.553 179.224 138.618 179.267 138.668L182.713 142.749C182.727 142.765 182.73 142.787 182.722 142.805C182.713 142.824 182.694 142.835 182.672 142.835L177.3 142.817C177.234 142.817 177.174 142.848 177.139 142.899L174.285 147.108C174.274 147.126 174.253 147.135 174.231 147.132C174.209 147.129 174.191 147.113 174.184 147.093L172.307 142.21C172.284 142.15 172.232 142.104 172.168 142.086L166.956 140.607C166.934 140.601 166.918 140.585 166.913 140.564C166.908 140.544 166.916 140.524 166.933 140.512L171.143 137.519C171.194 137.482 171.223 137.423 171.218 137.36L170.854 132.232C170.853 132.212 170.863 132.193 170.882 132.184C170.901 132.174 170.924 132.176 170.941 132.188L175.42 135.217C175.475 135.255 175.544 135.265 175.605 135.244L180.592 133.555C180.612 133.548 180.635 133.553 180.651 133.567C180.667 133.582 180.673 133.603 180.667 133.623L179.903 136.201",
    fill: "#FFFEAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.755 136.712L179.227 138.493C179.209 138.553 179.224 138.618 179.267 138.668L182.713 142.749C182.727 142.765 182.73 142.787 182.722 142.805C182.713 142.824 182.694 142.835 182.672 142.835L177.3 142.817C177.234 142.817 177.174 142.848 177.139 142.899L174.285 147.108C174.274 147.126 174.253 147.135 174.231 147.132C174.209 147.129 174.191 147.113 174.184 147.093L172.307 142.21C172.284 142.15 172.232 142.104 172.168 142.086L166.956 140.607C166.934 140.601 166.918 140.585 166.913 140.564C166.908 140.544 166.916 140.524 166.933 140.512L171.143 137.519C171.194 137.482 171.223 137.423 171.218 137.36L170.854 132.232C170.853 132.212 170.863 132.193 170.882 132.184C170.901 132.174 170.924 132.176 170.941 132.188L175.42 135.217C175.475 135.255 175.544 135.265 175.605 135.244L180.592 133.555C180.612 133.548 180.635 133.553 180.651 133.567C180.667 133.582 180.673 133.603 180.667 133.623L179.903 136.201",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0144 189.603L32.2595 189.734C32.1671 189.738 32.0827 189.785 32.0346 189.861L28.0557 196.008C28.0399 196.033 28.0109 196.047 27.981 196.044C27.951 196.041 27.9253 196.023 27.9147 195.996L25.2455 189.239C25.2126 189.156 25.1398 189.094 25.0503 189.073L17.7326 187.363C17.7025 187.357 17.6789 187.334 17.6726 187.305C17.6663 187.276 17.6785 187.247 17.7035 187.229L23.591 182.696C23.663 182.64 23.7021 182.554 23.6955 182.466L23.1499 175.259C23.147 175.23 23.1618 175.202 23.1878 175.187C23.2138 175.172 23.2465 175.172 23.2719 175.188L29.5683 179.143C29.6453 179.192 29.7424 179.201 29.8279 179.168L36.8166 176.426C36.8445 176.415 36.8764 176.42 36.8988 176.439C36.9213 176.459 36.9304 176.488 36.9223 176.516L34.9319 183.492C34.9067 183.577 34.9276 183.669 34.9878 183.736L39.8497 189.249C39.8691 189.271 39.8738 189.301 39.8617 189.328C39.8497 189.354 39.8231 189.372 39.7931 189.373L35.8038 189.562",
    fill: "#FFFEAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0144 189.603L32.2595 189.734C32.1671 189.738 32.0827 189.785 32.0346 189.861L28.0557 196.008C28.0399 196.033 28.0109 196.047 27.981 196.044C27.951 196.041 27.9253 196.023 27.9147 195.996L25.2455 189.239C25.2126 189.156 25.1398 189.094 25.0503 189.073L17.7326 187.363C17.7025 187.357 17.6789 187.334 17.6726 187.305C17.6663 187.276 17.6785 187.247 17.7035 187.229L23.591 182.696C23.663 182.64 23.7021 182.554 23.6955 182.466L23.1499 175.259C23.147 175.23 23.1618 175.202 23.1878 175.187C23.2138 175.172 23.2465 175.172 23.2719 175.188L29.5683 179.143C29.6453 179.192 29.7424 179.201 29.8279 179.168L36.8166 176.426C36.8445 176.415 36.8764 176.42 36.8988 176.439C36.9213 176.459 36.9304 176.488 36.9223 176.516L34.9319 183.492C34.9067 183.577 34.9276 183.669 34.9878 183.736L39.8497 189.249C39.8691 189.271 39.8738 189.301 39.8617 189.328C39.8497 189.354 39.8231 189.372 39.7931 189.373L35.8038 189.562",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.872 86.5514C133.606 86.5514 135.823 84.4539 135.823 81.8666C135.823 79.2792 133.606 77.1817 130.872 77.1817C128.138 77.1817 125.921 79.2792 125.921 81.8666C125.921 84.4539 128.138 86.5514 130.872 86.5514Z",
    fill: "#1D1E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.763 49.8221C120.568 50.9546 119.62 52.2988 118.975 53.7779C118.329 55.257 117.998 56.842 118 58.4423C118 59.1878 118.313 59.9027 118.87 60.4299C119.427 60.957 120.183 61.2532 120.97 61.2532C121.758 61.2532 122.514 60.957 123.071 60.4299C123.628 59.9027 123.941 59.1878 123.941 58.4423C123.936 57.5797 124.112 56.7248 124.459 55.9271C124.806 55.1293 125.316 54.4046 125.961 53.7949C127.286 52.6033 129.044 51.9388 130.872 51.9388C132.7 51.9388 134.458 52.6033 135.783 53.7949C136.77 54.7101 137.446 55.8838 137.723 57.165C138 58.4463 137.866 59.7767 137.338 60.9854C136.81 62.194 135.912 63.2257 134.76 63.948C133.608 64.6702 132.254 65.05 130.872 65.0385C130.087 65.0482 129.338 65.3475 128.783 65.8726C128.228 66.3976 127.912 67.107 127.901 67.8495V71.5973C127.901 72.3428 128.214 73.0578 128.772 73.585C129.329 74.1121 130.084 74.4083 130.872 74.4083C131.66 74.4083 132.415 74.1121 132.972 73.585C133.529 73.0578 133.842 72.3428 133.842 71.5973V70.3231C136.169 69.819 138.298 68.7015 139.981 67.0999C142.39 64.8101 143.743 61.7107 143.743 58.4797C143.743 55.2488 142.39 52.1494 139.981 49.8596C137.528 47.6453 134.27 46.4069 130.88 46.3999C127.49 46.393 124.226 47.618 121.763 49.8221Z",
    fill: "#1D1E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.872 86.5514C133.606 86.5514 135.823 84.4539 135.823 81.8666C135.823 79.2792 133.606 77.1817 130.872 77.1817C128.138 77.1817 125.921 79.2792 125.921 81.8666C125.921 84.4539 128.138 86.5514 130.872 86.5514Z",
    stroke: "#0D052C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.763 49.8221C120.568 50.9546 119.62 52.2988 118.975 53.7779C118.329 55.257 117.998 56.842 118 58.4423C118 59.1878 118.313 59.9027 118.87 60.4299C119.427 60.957 120.183 61.2532 120.97 61.2532C121.758 61.2532 122.514 60.957 123.071 60.4299C123.628 59.9027 123.941 59.1878 123.941 58.4423C123.936 57.5797 124.112 56.7248 124.459 55.9271C124.806 55.1293 125.316 54.4046 125.961 53.7949C127.286 52.6033 129.044 51.9388 130.872 51.9388C132.7 51.9388 134.458 52.6033 135.783 53.7949C136.77 54.7101 137.446 55.8838 137.723 57.165C138 58.4463 137.866 59.7767 137.338 60.9854C136.81 62.194 135.912 63.2257 134.76 63.948C133.608 64.6702 132.254 65.05 130.872 65.0385C130.087 65.0482 129.338 65.3475 128.783 65.8726C128.228 66.3976 127.912 67.107 127.901 67.8495V71.5973C127.901 72.3428 128.214 73.0578 128.772 73.585C129.329 74.1121 130.084 74.4083 130.872 74.4083C131.66 74.4083 132.415 74.1121 132.972 73.585C133.529 73.0578 133.842 72.3428 133.842 71.5973V70.3231C136.169 69.819 138.298 68.7015 139.981 67.0999C142.39 64.8101 143.743 61.7107 143.743 58.4797C143.743 55.2488 142.39 52.1494 139.981 49.8596C137.528 47.6453 134.27 46.4069 130.88 46.3999C127.49 46.393 124.226 47.618 121.763 49.8221Z",
    stroke: "#0D052C",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11079_417735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/noResults.48cb3c6b667cc8435c474bfbd5846d3a.svg";
export { ForwardRef as ReactComponent };